import {ConnecttocrudService} from '../../connecttocrud.service';
import {Item} from '../../item';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
    id: string;
    item: Item;
    item1: Item;
    columns: string[] = [];
    ITEMNAME: string;
    partner: string;
    account: string;
    entity: string;
    version: string;
    partnerKey: string;
    attributes: any;
    DBRefView = true;
    color = 'orange';
    checked = true;
    disabled = false;
    apiByDefinition: any;
    showDBRef: boolean;

    constructor(private _route: ActivatedRoute,
                private _service: ConnecttocrudService,
                private location: Location,
                private confPost: ConfService,
                public platform: LeftpanelComponent) {

    }

    toggleView() {
        this.DBRefView = !this.DBRefView;
    }

    getitemvalues(): any {
        this.id = this._route.snapshot.paramMap.get('id');

        /*this.confPost.getPartner(localStorage.getItem('partnerId')).subscribe( items => {
            items.accounts.forEach((data) => {
                if (data.account == this.account) {
                    data.entities.forEach((entity) => {
                        if (entity.entityname == this.entity) {
                            this.attributes = entity.attributes;
                            // this.version = entity.version;
                        }
                    });
                }
            });
        });*/
        this._service.getItemById(this.id, this.version, this.partner, this.account, this.entity).subscribe(
            item => {
                this.item = item[0];
                /*for (const itemval in item) {
                    this.columns.push(itemval);
                }*/
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching item. Please try after sometime.');
                // this.platform.openSnackBar('Error while getting this item' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        );
        this._service.getItemByIdWithNoDBRef(this.id, this.version, this.partner, this.account, this.entity).subscribe(
            item => {
                this.item1 = item[0];
                /*for (const itemval in item) {
                    this.columns.push(itemval);
                }*/
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Error while getting the item by Id with No DBRef. Please try after sometime.');
                // this.platform.openSnackBar('Error while getting the item by Id with No DBRef' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        );
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this._route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                this.partnerKey = localStorage.getItem('partnerKey');
                this.confPost.getEntity(params.partner, params.account, params.entity, params.version).subscribe(data => {
                    this.apiByDefinition = data;
                    if (this.apiByDefinition.database.toLowerCase() === 'default' || this.apiByDefinition.database.toLowerCase() === 'mongodb') {
                        this.showDBRef = true;
                    } else {
                        this.showDBRef = false;
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while retrieving the entity. Please try after sometime.');
                });
            });
        this.getitemvalues();
    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val, null, 2);
    }

}
